import { fork, all } from 'redux-saga/effects'

import runReviewsSurveyProcessSaga from './runReviewsSurveyProcessSaga'
import runReviewsSurveySubmitSaga from './runReviewsSurveySubmitSaga'

export default function* reviewsSurveysSaga() {
  yield all([fork(runReviewsSurveyProcessSaga), fork(runReviewsSurveySubmitSaga)])
}
